import React, { useState } from 'react';
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Container,
} from '@mui/material';

import {
  Business,
  Phone,
} from '@mui/icons-material';

import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { SetGreenhouseCreate, SetGreenmoduleCreate } from '../../Conections/GreenhouseConection';

const GreenmoduleCreate = () => {

  const goTo = useNavigate();
  const { getToken, getCompany } = useAuth();
  const { greenhouesid } = useParams();

  const [greenmodulename, setGreenmodulename] = useState("");

  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/greenhouse/creategreenhouse");
      if (permisionCan === 0) {
        goTo("/dashboard");
      }
    }
    else {
      goTo(`/login`);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGreenmodulename(value);
  };
  
  const validateForm = () => {
    const newErrors = {};
    if (!greenmodulename.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      console.log(greenmodulename, greenhouesid);
      const datos = await SetGreenmoduleCreate(
        getToken(),
        getCompany(),
        greenhouesid,
        greenmodulename.trim(),
      );
      console.log(datos);
      /* goTo(`/greenhouse/showgreenhouse/${datos}`);*/
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Crear Nuevo Invernadero
        </Typography>
        <Card>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Nombre del Invernadero"
                name="name"
                value={greenmodulename}
                onChange={handleChange}
                InputProps={{
                  startAdornment: <Business sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />

              <Box sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Crear Invernadero
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default GreenmoduleCreate;